var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2004",
    "data-name": "Groupe 2004",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 34.985,
    viewBox: "0 0 35 34.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_913",
    "data-name": "Rectangle 913",
    width: 35,
    height: 34.985,
    fill: "#ed5252"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2003",
    "data-name": "Groupe 2003",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8423",
    "data-name": "Trac\\xE9 8423",
    d: "M23.674,35.865a2.932,2.932,0,1,0-2.932-2.932,2.935,2.935,0,0,0,2.932,2.932m0-4.4a1.466,1.466,0,1,1-1.466,1.466,1.468,1.468,0,0,1,1.466-1.466",
    transform: "translate(-6.813 -8.006)",
    fill: "#ed5252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8424",
    "data-name": "Trac\\xE9 8424",
    d: "M23.674,22.662a2.207,2.207,0,0,0,2.185-2.028l.728-9.474a1.783,1.783,0,0,0,.019-.228,2.932,2.932,0,1,0-5.865,0,1.674,1.674,0,0,0,.015.2l.732,9.5a2.207,2.207,0,0,0,2.185,2.029m0-13.2a1.468,1.468,0,0,1,1.466,1.466l-.015.117L24.4,20.521a.725.725,0,0,1-1.447,0l-.743-9.587a1.468,1.468,0,0,1,1.466-1.466",
    transform: "translate(-6.813 -2.135)",
    fill: "#ed5252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8425",
    "data-name": "Trac\\xE9 8425",
    d: "M35,34.985l-3.677-9.456a16.855,16.855,0,1,0-5.91,5.865ZM16.861,1.466a15.393,15.393,0,0,1,13.027,23.6l-.2.312,2.755,7.086-7.187-2.693-.306.19A15.4,15.4,0,1,1,16.861,1.466",
    transform: "translate(0 0)",
    fill: "#ed5252"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoAttention);
export default __webpack_public_path__ + "static/media/PICTO_ATTENTION.ce02a3f774ecd150536c78bee758e49e.svg";
export { ForwardRef as ReactComponent };